import axios from 'axios';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CookieHandler from '../pages/LandingPage/Authentication/CookieHandler'

const DeleteRequest = async (path, isAuthenticated) => {
  let headers = {
    'Content-Type': 'application/json'
  };

  const apiUrl = process.env.REACT_APP_API_URL;
  console.log('API URL:', apiUrl);

  if (isAuthenticated) {
    const token = CookieHandler.getCookie('token');
    headers['Authorization'] = `Bearer ${token}`;
  }
  try {
    const response = await axios.delete(apiUrl+`/api/${path}`,{ headers});
    if (response.status === 204) {
      return;
    } else {
      // Display a toast for non-200 response
      toast.error('Server returned an error. Please try again later.');
    }
  } catch (error) {
    // Handle any errors that occur during the request
    console.error('Error in postData:', error); 
    toast.error('A network or Server error occurred. Please try again later.');
  }
};

export default DeleteRequest;